enum DemographicType {
  All = 'ALL',
  Age = 'AGE',
  AgeGender = 'AGE-GDR',
  Custom = 'CUS',
  Gender = 'GDR',
  HouseHoldIncome = 'HHI',
  Predefined = 'PREDEFINED',
  Ethnicity = 'ETH',
}

export default DemographicType;
